(function(){
  var canvas = document.getElementById('ccd-matrix');
  if(!canvas) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ctx = canvas.getContext('2d');
  var chars = 'CONTROLLEDCHAOSDEPARTMENTC.C.D.'.split('');
  var fontSize = 16;
  var columns, drops;

  function resize(){
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    columns = Math.ceil(canvas.width / fontSize);
    drops = [];
    for(var i = 0; i < columns; i++){ drops.push(Math.floor(Math.random() * -50)); }
  }
  resize();
  window.addEventListener('resize', resize);

  function draw(){
    ctx.fillStyle = 'rgba(12,11,10,0.08)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = fontSize + 'px "Space Mono", monospace';
    for(var i = 0; i < drops.length; i++){
      var char = chars[Math.floor(Math.random() * chars.length)];
      var x = i * fontSize;
      var y = drops[i] * fontSize;
      var roll = Math.random();
      ctx.fillStyle = roll < 0.07 ? '#F15A25' : (roll < 0.16 ? '#F2F0EA' : 'rgba(138,133,122,0.5)');
      ctx.fillText(char, x, y);
      if(y > canvas.height && Math.random() > 0.975){ drops[i] = 0; }
      drops[i]++;
    }
  }

  var timer = setInterval(draw, 45);
  document.addEventListener('visibilitychange', function(){
    clearInterval(timer);
    if(!document.hidden){ timer = setInterval(draw, 45); }
  });
})();
